var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.114,
    height: 18.118,
    viewBox: "0 0 20.114 18.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M454.357,259.2l-3,.012,1.265-17.684,3.007-.015Z",
    transform: "translate(-446.6 -241.514)",
    fill: "#efba29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M467.6,259.95l-3.006.016,1.266-17.685,3.007-.012Z",
    transform: "translate(-452.465 -241.849)",
    fill: "#efba29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M463.3,249.837l-.17,2.727-19.486.261.18-2.734Z",
    transform: "translate(-443.186 -245.201)",
    fill: "#efba29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M462.488,261.314l-.192,2.725-19.475.121.189-2.731Z",
    transform: "translate(-442.821 -250.284)",
    fill: "#efba29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.e98732a2841db224c4a8e4404b9e103b.svg";
export { ForwardRef as ReactComponent };